import { api } from "./client";

export interface Notification {
  id: string;
  title: string;
  message: string;
  notification_type: "info" | "warning" | "success" | "error";
  resource_id: string | null;
  is_read: boolean;
  created_at: string;
}

export async function listNotifications(): Promise<Notification[]> {
  return api.get<Notification[]>("/notifications/");
}

export async function markRead(id: string): Promise<Notification> {
  return api.patch<Notification>(`/notifications/${id}/read`);
}

export async function markAllRead(): Promise<void> {
  await api.post<void>("/notifications/read-all");
}
